import { Stack } from "expo-router";
import { TouchableOpacity } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useRouter } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";

export default function SuperAdminNotificationsLayout() {
  const router = useRouter();
  const colors = useThemeColors();

  const handleBack = () => {
    if (router.canGoBack()) {
      router.back();
    } else {
      router.replace("/(tabs)/admin");
    }
  };

  return (
    <Stack
      screenOptions={{
        headerStyle: {
          backgroundColor: colors.surface,
        },
        headerTintColor: colors.text,
        headerShadowVisible: false,
        headerLeft: () => (
          <TouchableOpacity onPress={handleBack} style={{ marginRight: 16 }}>
            <Ionicons name="arrow-back" size={24} color={colors.text} />
          </TouchableOpacity>
        ),
      }}
    >
      <Stack.Screen
        name="index"
        options={{
          title: "Systeem Notificaties",
        }}
      />
      <Stack.Screen
        name="push-tokens"
        options={{
          title: "Push Token Status",
        }}
      />
    </Stack>
  );
}

